module.exports = __webpack_public_path__ + "static/media/snoopyshowerrain01.d1b54503.gif";